import React, { useState, useEffect, useMemo } from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'
import useContactStore from '../stores/contactStore'
import timeFromNow from '../utils/timeFromNow'
import { orderStatus } from '../utils/constants'
import SellModal from '../components/layouts/SellModal'

const Sell = () => {
    const { contacts, fetchContacts } = useContactStore()
    const statuses = useMemo(() => orderStatus, [])
    const [modalShow, setModalShow] = useState(false)
    const [selectedContact, setSelectedRequest] = useState(null) // State to hold the selected request

    useEffect(() => {
        fetchContacts()
    }, [fetchContacts])

    const [visible, setVisible] = useState(8)

    const filteredData = contacts.filter((item) => {
        return ['offer'].includes(item.kind)
    })

    const showMoreItems = () => {
        setVisible((prevValue) => prevValue + 4)
    }

    const handleShowModal = (contact) => {
        if (contact) {
            setSelectedRequest(contact)
        } else {
            setSelectedRequest(null)
        }

        setModalShow(true)
    }

    return (
        <div>
            <Header />
            <section className="tf-activity tf-section">
                <div className="themesflat-container">
                    <h2 class="tf-title-heading ct style-2 fs-30 mg-bt-10">Bán cho chúng tôi</h2>
                    <div className="row">
                        <div className="col-xl-8 col-lg-9 col-md-8 col-12">
                            {filteredData.length > 0 ? (
                            <div className="box-activity">
                                {filteredData.slice(0, visible).map((item, index) => (
                                    <div key={index} className="sc-card-activity offer-activity style-2">
                                        <div className="content offer-content">
                                            <div className="infor">
                                                <div className="title offer-title">
                                                    <Link to="#" onClick={() => handleShowModal(item)}>
                                                        <h4>Yêu cầu #{item.id}</h4>
                                                    </Link>
                                                    <span className="author">
                                                        {statuses[item.status]?.name || 'Unknown'}
                                                    </span>
                                                </div>
                                                <h4>
                                                    {item.item_name}{' '}
                                                </h4>

                                                {item.steam_inventory_link ? (
                                                    <p>
                                                        <span className="author">
                                                            Inventory Link{' '}
                                                            <a href={item.steam_inventory_link}>
                                                                <i className="fa fa-link"></i>
                                                            </a>
                                                        </span>
                                                    </p>
                                                ) : (
                                                    ''
                                                )}

                                                <p>
                                                    <span className="author">Số điện thoại:</span>
                                                    {item.tel}
                                                </p>

                                                <p>
                                                    <span className="author">Ghi chú:</span>
                                                    {item.memo}
                                                </p>

                                                <div className="time mt-20">
                                                    <OverlayTrigger
                                                        placement="bottom"
                                                        overlay={
                                                            <Tooltip>
                                                                {new Date(item.created_at).toLocaleString()}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span>{timeFromNow(item.created_at)}</span>
                                                    </OverlayTrigger>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            ) : (
                                <div className="sc-card-activity style1">
                                    <p>Không có yêu cầu nào.</p>
                                </div>
                            )}

                            {visible < contacts.length && (
                                <div className="btn-activity mg-t-10 center">
                                    <Link
                                        to="#"
                                        id="load-more"
                                        className="sc-button loadmore fl-button pri-3"
                                        onClick={showMoreItems}
                                    >
                                        <span>Load More</span>
                                    </Link>
                                </div>
                            )}
                        </div>
                        <div className="col-xl-4 col-lg-3 col-md-4 col-12">
                            <div id="side-bar" className="side-bar style-2">
                                <div className="create-order">
                                    <div className="card-bottom">
                                        <a
                                            onClick={() => handleShowModal()}
                                            className="sc-button fl-button pri-3 no-bg"
                                        >
                                            <span>Tạo yêu cầu</span>
                                        </a>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
            <SellModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                contact={selectedContact} // Pass the selected request as a prop
            />
        </div>
    )
}

export default Sell
